/**
 * @template {any} T
 * @param {T} value
 * @returns {T}
 */
export const copy = (value) => {
  return JSON.parse(JSON.stringify(value));
};

/** @param {unknown} value */
export const isObject = (value) => {
  return value !== null && typeof value === 'object';
};

/**
 * @param {Record<string, unknown> | any[]} a
 * @param {Record<string, unknown> | any[]} b
 */
export const isEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
}

export const changedFields = (a, b, fields = []) => {
  /** @type {{list: string[], values: {key: string, previous: unknown, current: unknown}[]}} */
  const changedFields = { list: [], values: [] };
  for (const key in a) {
    if(fields.length > 0 && !fields.includes(key)) {
      continue;
    }

    if (a[key] !== b[key]) {
      changedFields.list.push(key);
      changedFields.values.push({ key, previous: a[key], current: b[key] });
    }
  }
  return changedFields;
}